import SquareCheckboxIcon from "../images/SquareCheckboxIcon.mjs";

/**
 * App selected checkbox
 * @see {GlyphIcon}
 * @see {SquareCheckboxIcon}
 */
const AppCheckboxOnIcon = class extends SquareCheckboxIcon {};

export default AppCheckboxOnIcon;